export default __webpack_public_path__ + "static/media/wh_ep2_accuse_wenny.9aac82cd.jpg";